<div class="chat-device-terminal-shell">
  <div class="chat-device-terminal-shell__screen" #terminalHost></div>
</div>